export const websites = {
  // "main-mfe": "https://main-mfe.shtdevops.xyz/#/login/",
  "main-mfe": "http://localhost:3000/#/login/",
  "staging": "https://staging.shtdevops.xyz/#/login/",
  "esc-dev": "https://esc-dev.shtdevops.xyz/#/login/",
};
